module.exports = __webpack_public_path__ + "stratumblue_mobile_banner.jpg?7930c1ffed50edbedcaa91e4a67a1dc4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/stratumblue_mobile_banner.jpg
// module id = 761
// module chunks = 2